import { CreateContentTemplateResult, TemplateResult } from "./ContentTemplateResult";
import { CreateContentRaw,RawHtml } from "./ContentRaw";
import { CreateContentText } from "./ContentText";
import { ComponentType, CreateContentComponent} from "./ContentComponent";
import { CreateContentArray } from "./ContentArray";

export type Content={
  Update:(v:any)=>void;
  Unload:()=>void;
  MatchForUpdate:(v:any)=>boolean;
}

export const enum ContentType  {
  Null,
  Text,
  Component,
  Raw,
  TemplateResult,
  NoChange,
  Array,
}

export function GetContentType(v:any):ContentType {
  if(v===null || v==="" || v===false) return ContentType.Null;
  if(v instanceof TemplateResult) return ContentType.TemplateResult;
  if(Array.isArray(v)) return v.length>0 && typeof v[0]==="function" ? ContentType.Component : ContentType.Array;
  if(v instanceof RawHtml) return ContentType.Raw;
  if(v instanceof NoChange)  return ContentType.NoChange;
  if(typeof v ==="string" || typeof v==="number" || typeof v==="object") return ContentType.Text;
  throw new Error("Katla: Unknown content type: " + typeof v);
}

export function CreateContent(v:any,setContent:(newContent:Node)=>void,curComp:ComponentType):Content {
  let tp=GetContentType(v)
  switch(tp) {
    case ContentType.Null:
      setContent(null);
      return {Update:v=>{},Unload:()=>{},MatchForUpdate:v=>true};
    case ContentType.Text:
      return CreateContentText(<string|number|object>v,setContent);
    case ContentType.Component:
      return CreateContentComponent(v,setContent,curComp);
    case ContentType.Raw:
      return CreateContentRaw(v,setContent);
    case ContentType.TemplateResult:
      return CreateContentTemplateResult(v,setContent,curComp);
    case ContentType.Array:
      return CreateContentArray(v,setContent,curComp);
    case ContentType.NoChange:
      throw new Error("Katla: NoChange at creation");
  }   
}

export class NoChange {
}